/**
 * If we are using CDN, let webpack know that's where we will get our chunks from
 */
export function setCdnDomain(cdnOrigin: string): void {
    let cdnDomain: string;

    if (cdnOrigin.length) {
        cdnDomain = `https://${cdnOrigin}`;
    } else {
        // In cases where there is no CDN Domain provided, explicitly set it to the origin.
        cdnDomain = window.location.origin;
    }

    cdnDomain = `${cdnDomain}/bundles/`;

    __webpack_public_path__ = cdnDomain;
}
